export default "__VITE_ASSET__urUCiICc__"